import { Clock, Flame, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurStation() {
  return <section data-section-id="223927" id="find-us-in-rapid-city" className="bg-background text-foreground relative w-full h-[600px] md:h-[700px] overflow-hidden">
      {}
      <iframe title="Rapid Tech Works Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2864.5!2d-103.15!3d44.05!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMDBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzBWMzA!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus" className="absolute inset-0 w-full h-full border-0 pointer-events-none" style={{
      filter: "grayscale(100%) invert(5%) contrast(90%) hue-rotate(200deg) brightness(1.1)"
    }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none z-10">
        <div className="relative flex items-center justify-center">
          {}
          <div className="absolute inset-0 bg-primary/20 rounded-full animate-ping" />
          <div className="bg-card/90 backdrop-blur-sm p-4 rounded-full border border-primary/30 shadow-xl">
            <Flame className="w-12 h-12 text-primary drop-shadow-md" fill="currentColor" />
          </div>
        </div>
        <div className="mt-2 px-3 py-1 bg-secondary/90 backdrop-blur-md rounded-md border border-secondary text-sm font-default font-bold text-secondary-foreground shadow-lg">
          Rapid Tech Works
        </div>
      </div>

      {}
      <div className="absolute bottom-6 left-6 right-6 md:right-auto md:bottom-12 md:left-12 z-20 md:w-[400px]">
        
      </div>
    </section>;
}